import {connectWithCore} from 'framework/hocs';
import React from 'react';
import {Button} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {evaluateOperator} from 'common/utils';
import _ from 'lodash';

export const DynamicRestAPICallButton = ({
  data,
  apiConfig,
  buttonConfig,
  confirmModal,
  successMessage,
  reloadPage,
  redirect,
  redirectParams,
  saveToSession,
  contextPathToSave,
  saveEntitySessionData,
  ...restProps
}) => {
  const lookupData = {...restProps, ...data};

  const handleClick = () => {
    if (apiConfig) {
      const {service, action, params} = apiConfig;
      if (service && action && params) {
        const {service, action, params} = apiConfig;

        const args = {};
        _.each(params, (value, key) => {
          args[key] = _.get(lookupData, value, value);
        });

        REST[service][action]({...args})
          .then(REST.handler.handleResponse)
          .then((res) => {
            if (confirmModal) {
              confirmModal(successMessage);
            }
            if (saveToSession) {
              saveEntitySessionData(contextPathToSave, {
                ...res,
                loading: false,
              });
            }
            if (reloadPage) {
              window.location.reload();
            } else if (!_.isEmpty(redirect)) {
              window.location.href = redirect;
            } else if (redirectParams) {
              const {paramsNames, redirectLink} = redirectParams;
              let link = redirectLink;
              _.forEach(paramsNames, (param) => {
                let value = _.get(res, param, null);
                link = link.replace(`{${param}}`, value);
              });
              window.location.href = link;
            }
          })
          .catch((error) => console.log(error));
      }
    }
  };

  let buttonDisabled = false;

  const {disableOn} = buttonConfig;
  _.forEach(disableOn, (disabledOn) => {
    const propValue = _.get(restProps, disabledOn.propsPath);
    const propObj =
      propValue ||
      _.mapValues(_.keyBy(disabledOn.propsArray), (propsPath) =>
        _.get(restProps, propsPath)
      );

    buttonDisabled =
      buttonDisabled ||
      evaluateOperator(
        disabledOn.operator,
        propObj,
        disabledOn.value,
        disabledOn.checkType
      );
  });

  return (
    <Button
      className={
        !_.isEmpty(buttonConfig.className) ? buttonConfig.className : 'ui blue button'
      }
      onClick={() => {
        handleClick();
      }}
      disabled={buttonDisabled}
    >
      {buttonConfig.label}
    </Button>
  );
};

export default connectWithCore(DynamicRestAPICallButton);
